<template>
    <div id="categories-tree" class="is-relative">
        <b-loading :active="loading" :is-full-page="false"></b-loading>
        <p class="menu-label mt-4">Categories</p>
        <v-jstree :data="categories"
                  whole-row
                  @item-click="itemClick"
        ></v-jstree>
        <b-button tag="router-link"
                  :to="{name: 'model.action', params: {resource: 'category', action: 'create', routeKey: parentId}}"
                  type="is-primary"
                  class="is-uppercase mt-3"
                  label="Add Subcategory"
                  expanded outlined size="is-small"></b-button>
    </div>
</template>

<script>
import VJstree from 'vue-jstree';

export default {
    components: {VJstree},
    props: {
        parentId: {
            type: Number,
            required: true
        },
        refresh: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            loading: true,
            canRemove: false,
            categories: []
        }
    },
    created() {
        this.setup();
    },
    methods: {
        setup() {
            axios.get(`/category/tree/${this.parentId}`)
                .then(response => {
                    this.categories = response.data;
                    this.loading = false;
                    this.$emit('refreshed');
                })
        },
        itemClick (node, item) {
            this.$router.push({name: 'model.action', params: {resource: 'category', action: 'edit', routeKey: item.id}})
        }
    },
    watch: {
        $route() {
            this.setup();
        },
        refresh(value) {
            if(value) {
                this.setup();
            }
        },
        parentId() {
            this.setup()
        }
    }
}
</script>
